<template lang='pug' src='./accessibility.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Header from 'components/header/header'
import Footer from 'components/footer/footer'

export default {
  name: 'Accessibility',
  computed: {
    props () {
      return this.$store.state.pages['thank-you']
    },
    propsheader () {
      return this.$store.state.app['header']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Header,
    Footer
  },
  data () {
    return {
      companyName: 'New Smiles Orthodontics', // Fill this in
      domain: "<a href='https://www.newsmilesortho.com'>newsmilesortho.com</a>", // Fill this in
      email: "<a href='mailto:info@newsmilesortho.com'>info@newsmilesortho.com</a>", // Fill this in
      phone: "<a href='tel:(585) 889-8810'>(585) 889-8810</a>", // Fill this in
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// accessibility.vue?2024c3fb